export const beVerbQuestions = [
  {
    questionNumber: 1,
    questionText: "Is the cafeteria open today?",
    choices: {
      A: "No, it's closed for cleaning.",
      B: "I'll open the window.",
      C: "That cafeteria has great food.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "오늘 구내식당이 열려 있나요?",
      choices: {
        A: "아니요, 청소 때문에 닫혀 있습니다.",
        B: "창문을 열겠습니다.",
        C: "그 구내식당은 음식이 맛있습니다.",
      },
    },
    explanation:
      "Be동사로 시작하는 yes/no 의문문에 대해 구내식당의 운영 상태를 묻는 질문에는 명확한 답변이 필요합니다. A는 구내식당이 닫혀 있는 이유를 명확하게 설명하고 있습니다. B는 창문을 연다는 관련 없는 내용이고, C는 구내식당의 음식 품질에 대한 언급으로 운영 상태를 묻는 질문에 부적절합니다.",
  },
  {
    questionNumber: 2,
    questionText: "Are you available at three o'clock?",
    choices: {
      A: "The clock is on the wall.",
      B: "Yes, I'm free after lunch.",
      C: "I was available yesterday.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "3시에 시간 되시나요?",
      choices: {
        A: "시계는 벽에 있습니다.",
        B: "네, 점심 식사 후에 시간이 됩니다.",
        C: "어제는 시간이 됐었습니다.",
      },
    },
    explanation:
      "Be동사로 시작하는 yes/no 의문문에 대해 특정 시간의 가능 여부를 묻는 질문에는 명확한 답변이 필요합니다. B는 3시에 시간이 된다는 것을 명확하게 표현하고 있습니다. A는 시계의 위치에 대한 관련 없는 정보이고, C는 과거의 가능 여부를 언급하고 있어 현재의 가능 여부를 묻는 질문에 부적절합니다.",
  },
  {
    questionNumber: 3,
    questionText: "Is this seat taken?",
    choices: {
      A: "I'll take a taxi later.",
      B: "Yes, someone is sitting here.",
      C: "The seats were all cleaned this morning.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "이 자리가 사용 중인가요?",
      choices: {
        A: "나중에 택시를 탈 것입니다.",
        B: "네, 누군가 여기 앉아 있습니다.",
        C: "좌석은 오늘 아침에 모두 청소되었습니다.",
      },
    },
    explanation:
      "Be동사로 시작하는 yes/no 의문문에 대해 자리의 사용 여부를 묻는 질문에는 명확한 답변이 필요합니다. B는 자리가 이미 사용 중임을 명확하게 표현하고 있습니다. A는 택시에 대한 관련 없는 내용이고, C는 좌석 청소에 관한 정보로 현재 자리의 사용 여부에 대한 직접적인 답변이 아니어서 부적절합니다.",
  },
  {
    questionNumber: 4,
    questionText: "Were the documents printed already?",
    choices: {
      A: "No, I haven't done that yet.",
      B: "The printer is in the hallway.",
      C: "I forgot my ID badge this morning.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "서류들이 이미 인쇄되었나요?",
      choices: {
        A: "아니요, 아직 그것을 하지 않았습니다.",
        B: "프린터는 복도에 있습니다.",
        C: "오늘 아침에 제 ID 배지를 잊어버렸습니다.",
      },
    },
    explanation:
      "과거 시제의 Be동사로 시작하는 yes/no 의문문에 대해 문서 인쇄 여부를 묻는 질문에는 명확한 답변이 필요합니다. A는 아직 인쇄하지 않았다는 것을 명확하게 표현하고 있습니다. B는 프린터의 위치에 대한 정보이고, C는 ID 배지를 잊어버렸다는 관련 없는 내용으로 인쇄 여부를 묻는 질문에 부적절합니다.",
  },
  {
    questionNumber: 5,
    questionText: "Is the package in the mailroom?",
    choices: {
      A: "The mailing address is correct.",
      B: "Yes, it arrived this morning.",
      C: "I left my phone in the cafeteria.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "그 소포가 우편실에 있나요?",
      choices: {
        A: "우편 주소가 정확합니다.",
        B: "네, 오늘 아침에 도착했습니다.",
        C: "저는 카페테리아에 제 전화기를 두고 왔습니다.",
      },
    },
    explanation:
      "Be동사로 시작하는 yes/no 의문문에 대해 소포의 위치를 묻는 질문에는 명확한 답변이 필요합니다. B는 소포가 우편실에 있으며 도착 시간까지 명확하게 표현하고 있습니다. A는 우편 주소의 정확성에 대한 언급이고, C는 전화기를 카페테리아에 두고 왔다는 관련 없는 내용으로 소포의 위치를 묻는 질문에 부적절합니다.",
  },
  {
    questionNumber: 6,
    questionText: "Are we supposed to bring our laptops?",
    choices: {
      A: "I brought mine just in case.",
      B: "It's on the top shelf.",
      C: "No, I'm printing something.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "우리가 노트북을 가져와야 하나요?",
      choices: {
        A: "혹시 몰라서 제 것은 가져왔습니다.",
        B: "그것은 맨 위 선반에 있습니다.",
        C: "아니요, 저는 무언가를 인쇄하고 있습니다.",
      },
    },
    explanation:
      "Be동사로 시작하는 yes/no 의문문에 대해 노트북 지참 여부를 묻는 질문에는 명확한 답변이 필요합니다. A는 확실하지 않은 상황에서 미리 준비했다는 것을 표현하고 있어 적절합니다. B는 위치에 대한 관련 없는 정보이고, C는 인쇄 작업에 대한 언급으로 노트북 지참 여부를 묻는 질문에 부적절합니다.",
  },
  {
    questionNumber: 7,
    questionText: "Is the printer connected to the network?",
    choices: {
      A: "My password was changed yesterday.",
      B: "Yes, it's online now.",
      C: "I connected my phone earlier.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "프린터가 네트워크에 연결되어 있나요?",
      choices: {
        A: "제 비밀번호는 어제 변경되었습니다.",
        B: "네, 지금 온라인 상태입니다.",
        C: "저는 이전에 제 전화기를 연결했습니다.",
      },
    },
    explanation:
      "Be동사로 시작하는 yes/no 의문문에 대해 프린터의 네트워크 연결 상태를 묻는 질문에는 명확한 답변이 필요합니다. B는 프린터가 현재 네트워크에 연결되어 있다는 것을 명확하게 표현하고 있습니다. A는 비밀번호 변경에 대한 관련 없는 내용이고, C는 전화기 연결에 대한 언급으로 프린터의 네트워크 연결 상태를 묻는 질문에 부적절합니다.",
  },
  {
    questionNumber: 8,
    questionText: "Is the software installed correctly?",
    choices: {
      A: "Yes, it's working perfectly.",
      B: "I installed the air conditioner.",
      C: "The instructions are printed.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "소프트웨어가 올바르게 설치되었나요?",
      choices: {
        A: "네, 완벽하게 작동하고 있습니다.",
        B: "에어컨을 설치했습니다.",
        C: "설명서가 인쇄되어 있습니다.",
      },
    },
    explanation:
      "Be동사로 시작하는 yes/no 의문문에 대해 소프트웨어 설치 상태를 묻는 질문에는 명확한 답변이 필요합니다. A는 소프트웨어가 올바르게 설치되어 잘 작동하고 있다는 것을 명확하게 표현하고 있습니다. B는 에어컨 설치에 대한 관련 없는 내용이고, C는 설명서에 대한 언급으로 소프트웨어 설치 상태를 묻는 질문에 부적절합니다.",
  },
  {
    questionNumber: 9,
    questionText: "Are these documents for the finance team?",
    choices: {
      A: "Yes, please leave them on that desk.",
      B: "The team is going to France.",
      C: "No, they were written yesterday.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "이 서류들은 재무팀을 위한 것인가요?",
      choices: {
        A: "네, 그 책상 위에 놓아주세요.",
        B: "팀이 프랑스로 갈 예정입니다.",
        C: "아니요, 그것들은 어제 작성되었습니다.",
      },
    },
    explanation:
      "Be동사로 시작하는 yes/no 의문문에 대해 서류의 대상을 묻는 질문에는 명확한 답변이 필요합니다. A는 서류가 재무팀을 위한 것임을 확인하고 추가 지시까지 제공하고 있습니다. B는 팀의 출장 계획에 대한 관련 없는 내용이고, C는 서류 작성 시점에 대한 언급으로 서류의 대상을 묻는 질문에 부적절합니다.",
  },
  {
    questionNumber: 10,
    questionText: "Is the client arriving before noon?",
    choices: {
      A: "Yes, his flight lands at 11.",
      B: "The airport is in Terminal 2.",
      C: "No, I sent the invoice already.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "고객이 정오 전에 도착하나요?",
      choices: {
        A: "네, 그의 비행기가 11시에 착륙합니다.",
        B: "공항은 2번 터미널에 있습니다.",
        C: "아니요, 이미 청구서를 보냈습니다.",
      },
    },
    explanation:
      "Be동사로 시작하는 yes/no 의문문에 대해 고객의 도착 시간을 묻는 질문에는 명확한 답변이 필요합니다. A는 고객이 정오 전인 11시에 도착할 것임을 명확하게 표현하고 있습니다. B는 공항 터미널에 대한 관련 없는 정보이고, C는 청구서 발송에 대한 언급으로 고객의 도착 시간을 묻는 질문에 부적절합니다.",
  },
  {
    questionNumber: 11,
    questionText: "Are the meeting minutes on the shared drive?",
    choices: {
      A: "No, I'll upload them now.",
      B: "The minutes took a long time to write.",
      C: "I'm driving to the client's office.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "회의록이 공유 드라이브에 있나요?",
      choices: {
        A: "아니요, 지금 업로드하겠습니다.",
        B: "회의록 작성에 시간이 많이 걸렸습니다.",
        C: "고객사 사무실로 운전 중입니다.",
      },
    },
    explanation:
      "Be동사로 시작하는 yes/no 의문문에 대해 회의록의 위치를 묻는 질문에는 명확한 답변이 필요합니다. A는 회의록이 공유 드라이브에 없다고 명확히 답하고 지금 업로드하겠다는 적절한 후속 조치를 제시합니다. B는 회의록 작성 시간에 관한 내용으로 공유 드라이브 존재 여부와 관련이 없으며, C는 고객사로 운전 중이라는 내용으로 회의록 위치와 전혀 관련이 없습니다.",
  },
  {
    questionNumber: 12,
    questionText: "Is that your company's new logo?",
    choices: {
      A: "Yes, we updated it last week.",
      B: "I wrote a slogan for them.",
      C: "Local shops open at nine.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "저것이 귀사의 새 로고인가요?",
      choices: {
        A: "네, 지난주에 업데이트했습니다.",
        B: "그들을 위해 슬로건을 작성했습니다.",
        C: "지역 상점들은 9시에 문을 엽니다.",
      },
    },
    explanation:
      "Be동사로 시작하는 yes/no 의문문에 대해 회사 로고에 관한 질문에는 명확한 답변이 필요합니다. A는 새 로고를 지난주에 업데이트했다고 확인해주는 적절한 응답입니다. B는 슬로건 작성에 관한 내용으로 로고에 대한 질문에 직접적인 답변이 아니며, C는 상점 영업시간에 관한 내용으로 질문과 전혀 관련이 없습니다.",
  },
  {
    questionNumber: 13,
    questionText: "Are your headphones wireless?",
    choices: {
      A: "The speaker is very loud.",
      B: "Yes, they use Bluetooth.",
      C: "I usually listen to podcasts.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "당신의 헤드폰은 무선인가요?",
      choices: {
        A: "스피커가 매우 시끄럽습니다.",
        B: "네, 블루투스를 사용합니다.",
        C: "저는 보통 팟캐스트를 듣습니다.",
      },
    },
    explanation:
      "Be동사로 시작하는 yes/no 의문문에 대해 헤드폰의 특성을 묻는 질문에는 명확한 답변이 필요합니다. B는 헤드폰이 블루투스를 사용하는 무선 헤드폰임을 확인해주는 적절한 응답입니다. A는 스피커의 볼륨에 관한 내용으로 헤드폰의 무선 여부와 관련이 없으며, C는 팟캐스트 청취 습관에 관한 내용으로 질문에 직접적인 답변이 아닙니다.",
  },
  {
    questionNumber: 14,
    questionText: "Is the break room on this floor?",
    choices: {
      A: "The hallway is newly painted.",
      B: "This floor is very clean.",
      C: "Yes, next to the vending machine.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "휴게실이 이 층에 있나요?",
      choices: {
        A: "복도가 새로 페인트칠 되었습니다.",
        B: "이 층은 매우 깨끗합니다.",
        C: "네, 자판기 옆에 있습니다.",
      },
    },
    explanation:
      "Be동사로 시작하는 yes/no 의문문에 대해 휴게실 위치를 묻는 질문에는 명확한 답변이 필요합니다. C는 휴게실이 이 층의 자판기 옆에 있다고 확인해주는 적절한 응답입니다. A는 복도의 페인트에 관한 내용으로 휴게실 위치와 관련이 없으며, B는 층의 청결 상태에 관한 내용으로 휴게실 위치에 대한 직접적인 답변이 아닙니다.",
  },
  {
    questionNumber: 15,
    questionText: "Are those new uniforms for the staff?",
    choices: {
      A: "He works at the shipping department.",
      B: "I ordered coffee for the team.",
      C: "Yes, they just arrived yesterday.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "저것들이 직원들을 위한 새 유니폼인가요?",
      choices: {
        A: "그는 배송부서에서 일합니다.",
        B: "팀을 위해 커피를 주문했습니다.",
        C: "네, 어제 막 도착했습니다.",
      },
    },
    explanation:
      "Be동사로 시작하는 yes/no 의문문에 대해 유니폼에 관한 질문에는 명확한 답변이 필요합니다. C는 '네, 어제 막 도착했습니다'라고 말하며 새 유니폼에 대해 직접적으로 확인해주는 적절한 응답입니다. A는 배송부서에서 일한다는 내용으로 유니폼과 관련이 없으며, B는 커피 주문에 관한 내용으로 질문과 전혀 관련이 없습니다.",
  },
  {
    questionNumber: 16,
    questionText: "Is this form required for registration?",
    choices: {
      A: "I forgot my password.",
      B: "Yes, all applicants must complete it.",
      C: "She registered for yoga.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "이 양식이 등록에 필요한가요?",
      choices: {
        A: "비밀번호를 잊어버렸습니다.",
        B: "네, 모든 지원자들이 이것을 작성해야 합니다.",
        C: "그녀는 요가에 등록했습니다.",
      },
    },
    explanation:
      "Be동사로 시작하는 yes/no 의문문에 대해 양식의 필요성을 묻는 질문에는 명확한 답변이 필요합니다. B는 모든 지원자가 해당 양식을 작성해야 한다고 확인해주는 적절한 응답입니다. A는 비밀번호 분실에 관한 내용으로 양식의 필요성과 관련이 없으며, C는 요가 등록에 관한 내용으로 질문에 직접적인 답변이 아닙니다.",
  },
  {
    questionNumber: 17,
    questionText: "Are the lights off in the storage room?",
    choices: {
      A: "I turned them off before leaving.",
      B: "I stored the boxes last week.",
      C: "The room is very dark.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "창고의 불이 꺼져 있나요?",
      choices: {
        A: "떠나기 전에 불을 껐습니다.",
        B: "지난주에 상자들을 보관했습니다.",
        C: "그 방은 매우 어둡습니다.",
      },
    },
    explanation:
      "Be동사로 시작하는 yes/no 의문문에 대해 창고 조명 상태를 묻는 질문에는 명확한 답변이 필요합니다. A는 떠나기 전에 불을 껐다고 확인해주는 적절한 응답입니다. B는 상자 보관에 관한 내용으로 조명 상태와 관련이 없으며, C는 방이 어둡다는 사실을 언급하지만 불이 꺼져 있는지에 대한 직접적인 답변이 아닙니다.",
  },
  {
    questionNumber: 18,
    questionText: "Is your team finished with the report?",
    choices: {
      A: "The report is very long.",
      B: "Yes, we submitted it this morning.",
      C: "My team meets every Friday.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "당신의 팀이 보고서를 완료했나요?",
      choices: {
        A: "보고서가 매우 깁니다.",
        B: "네, 오늘 아침에 제출했습니다.",
        C: "제 팀은 매주 금요일에 모입니다.",
      },
    },
    explanation:
      "Be동사로 시작하는 yes/no 의문문에 대해 보고서 완료 여부를 묻는 질문에는 명확한 답변이 필요합니다. B는 오늘 아침에 보고서를 제출했다고 확인해주는 적절한 응답입니다. A는 보고서의 길이에 관한 내용으로 완료 여부와 직접적인 관련이 없으며, C는 팀 미팅 일정에 관한 내용으로 질문에 대한 답변이 아닙니다.",
  },
  {
    questionNumber: 19,
    questionText: "Is there an outlet near the desk?",
    choices: {
      A: "Yes, just to the right.",
      B: "I left my notebook at home.",
      C: "The carpet is very clean.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "책상 근처에 콘센트가 있나요?",
      choices: {
        A: "네, 바로 오른쪽에 있습니다.",
        B: "제 노트북을 집에 두고 왔습니다.",
        C: "카펫이 매우 깨끗합니다.",
      },
    },
    explanation:
      "Be동사로 시작하는 yes/no 의문문에 대해 콘센트 위치를 묻는 질문에는 명확한 답변이 필요합니다. A는 콘센트가 오른쪽에 있다고 확인해주는 적절한 응답입니다. B는 노트북을 집에 두고 왔다는 내용으로 콘센트 위치와 관련이 없으며, C는 카펫의 청결 상태에 관한 내용으로 질문에 대한 답변이 아닙니다.",
  },
  {
    questionNumber: 20,
    questionText: "Is your supervisor in the building?",
    choices: {
      A: "I submitted the report.",
      B: "Yes, he's on the second floor.",
      C: "The elevator isn't working.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "당신의 상사가 건물 안에 있나요?",
      choices: {
        A: "보고서를 제출했습니다.",
        B: "네, 그는 2층에 있습니다.",
        C: "엘리베이터가 작동하지 않습니다.",
      },
    },
    explanation:
      "Be동사로 시작하는 yes/no 의문문에 대해 상사의 위치를 묻는 질문에는 명확한 답변이 필요합니다. B는 상사가 2층에 있다고 확인해주는 적절한 응답입니다. A는 보고서 제출에 관한 내용으로 상사의 위치와 관련이 없으며, C는 엘리베이터 상태에 관한 내용으로 질문에 대한 직접적인 답변이 아닙니다.",
  },
  {
    questionNumber: 21,
    questionText: "Are the windows open in the office?",
    choices: {
      A: "Yes, they're letting in a breeze.",
      B: "I used Windows 10.",
      C: "We opened the file already.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "사무실의 창문이 열려 있나요?",
      choices: {
        A: "네, 바람이 들어오고 있습니다.",
        B: "저는 윈도우 10을 사용했습니다.",
        C: "우리는 이미 파일을 열었습니다.",
      },
    },
    explanation:
      "Be동사로 시작하는 yes/no 의문문에 대해 창문 상태를 묻는 질문에는 명확한 답변이 필요합니다. A는 창문이 열려 있고 바람이 들어온다고 확인해주는 적절한 응답입니다. B는 컴퓨터 운영체제에 관한 내용으로 실제 창문과 관련이 없으며, C는 파일을 열었다는 내용으로 창문 상태와 관련이 없습니다.",
  },
  {
    questionNumber: 22,
    questionText: "Is the parking permit still valid?",
    choices: {
      A: "I left it at home.",
      B: "Yes, it expires next month.",
      C: "The office has a parking lot.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "주차 허가증이 아직 유효한가요?",
      choices: {
        A: "집에 두고 왔습니다.",
        B: "네, 다음 달에 만료됩니다.",
        C: "사무실에는 주차장이 있습니다.",
      },
    },
    explanation:
      "Be동사로 시작하는 yes/no 의문문에 대해 주차 허가증의 유효성을 묻는 질문에는 명확한 답변이 필요합니다. B는 허가증이 다음 달에 만료된다고 확인해주는 적절한 응답입니다. A는 허가증을 집에 두고 왔다는 내용으로 유효성에 대한 답변이 아니며, C는 주차장 존재 여부에 관한 내용으로 허가증 유효성과 관련이 없습니다.",
  },
  {
    questionNumber: 23,
    questionText: "Are those chairs for the guests?",
    choices: {
      A: "No, they're for staff meetings.",
      B: "The chairs are very comfortable.",
      C: "I sat there earlier.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "저 의자들은 손님용인가요?",
      choices: {
        A: "아니요, 직원 회의용입니다.",
        B: "의자들이 매우 편안합니다.",
        C: "저는 거기에 일찍 앉아있었습니다.",
      },
    },
    explanation:
      "Be동사로 시작하는 yes/no 의문문에 대해 의자의 용도를 묻는 질문에는 명확한 답변이 필요합니다. A는 의자가 손님용이 아니라 직원 회의용이라고 명확히 답변하는 적절한 응답입니다. B는 의자의 편안함에 관한 내용으로 용도와 직접적인 관련이 없으며, C는 과거에 앉았던 경험을 언급하는 것으로 의자의 용도에 대한 답변이 아닙니다.",
  },
  {
    questionNumber: 24,
    questionText: "Is your laptop plugged in?",
    choices: {
      A: "No, I forgot the charger.",
      B: "I used a projector yesterday.",
      C: "The desk has a drawer.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "노트북이 전원에 연결되어 있나요?",
      choices: {
        A: "아니요, 충전기를 잊어버렸습니다.",
        B: "어제 프로젝터를 사용했습니다.",
        C: "책상에는 서랍이 있습니다.",
      },
    },
    explanation:
      "Be동사로 시작하는 yes/no 의문문에 대해 노트북의 전원 연결 상태를 묻는 질문에는 명확한 답변이 필요합니다. A는 충전기를 잊어버려서 연결되어 있지 않다고 확인해주는 적절한 응답입니다. B는 프로젝터 사용에 관한 내용으로 노트북 전원과 관련이 없으며, C는 책상 서랍에 관한 내용으로 질문에 대한 답변이 아닙니다.",
  },
  {
    questionNumber: 25,
    questionText: "Was your interview in the afternoon?",
    choices: {
      A: "Yes, it started at 2 p.m.",
      B: "I'll view the results later.",
      C: "I reviewed the notes.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "당신의 면접은 오후에 있었나요?",
      choices: {
        A: "네, 오후 2시에 시작했습니다.",
        B: "나중에 결과를 볼 것입니다.",
        C: "메모를 검토했습니다.",
      },
    },
    explanation:
      "Be동사로 시작하는 yes/no 의문문에 대해 면접 시간을 묻는 질문에는 명확한 답변이 필요합니다. A는 면접이 오후 2시에 시작했다고 확인해주는 적절한 응답입니다. B는 결과를 나중에 볼 것이라는 미래 계획에 관한 내용으로 면접 시간과 관련이 없으며, C는 메모 검토에 관한 내용으로 질문에 대한 직접적인 답변이 아닙니다.",
  },
  {
    questionNumber: 26,
    questionText: "Is the storage room locked?",
    choices: {
      A: "The hallway is dark.",
      B: "No, it's open right now.",
      C: "I brought some boxes.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "창고가 잠겨 있나요?",
      choices: {
        A: "복도가 어둡습니다.",
        B: "아니요, 지금 열려 있습니다.",
        C: "상자를 몇 개 가져왔습니다.",
      },
    },
    explanation:
      "Be동사로 시작하는 yes/no 의문문에 대해 창고의 잠금 상태를 묻는 질문에는 명확한 답변이 필요합니다. B는 창고가 지금 열려 있다고 확인해주는 적절한 응답입니다. A는 복도의 조명 상태에 관한 내용으로 창고 잠금과 관련이 없으며, C는 상자를 가져왔다는 내용으로 질문에 대한 답변이 아닙니다.",
  },
  {
    questionNumber: 27,
    questionText: "Are these reports ready to print?",
    choices: {
      A: "Yes, I just double-checked them.",
      B: "I'm reporting to a new team.",
      C: "The printer is in the hallway.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "이 보고서들이 인쇄할 준비가 되었나요?",
      choices: {
        A: "네, 방금 다시 확인했습니다.",
        B: "저는 새 팀에 보고하고 있습니다.",
        C: "프린터는 복도에 있습니다.",
      },
    },
    explanation:
      "Be동사로 시작하는 yes/no 의문문에 대해 보고서의 인쇄 준비 상태를 묻는 질문에는 명확한 답변이 필요합니다. A는 보고서를 다시 확인했고 인쇄할 준비가 되었다고 확인해주는 적절한 응답입니다. B는 새 팀에 보고한다는 내용으로 보고서 인쇄 준비와 관련이 없으며, C는 프린터 위치에 관한 내용으로 질문에 대한 직접적인 답변이 아닙니다.",
  },
  {
    questionNumber: 28,
    questionText: "Is the supply order complete?",
    choices: {
      A: "The boxes were expensive.",
      B: "Yes, I received confirmation.",
      C: "The order was late last time.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "물품 주문이 완료되었나요?",
      choices: {
        A: "상자들이 비쌌습니다.",
        B: "네, 확인을 받았습니다.",
        C: "지난번에는 주문이 늦었습니다.",
      },
    },
    explanation:
      "Be동사로 시작하는 yes/no 의문문에 대해 물품 주문 완료 여부를 묻는 질문에는 명확한 답변이 필요합니다. B는 확인을 받았다고 하며 주문이 완료되었음을 확인해주는 적절한 응답입니다. A는 상자 가격에 관한 내용으로 주문 완료 여부와 관련이 없으며, C는 과거 주문 지연에 관한 내용으로 현재 주문 상태에 대한 답변이 아닙니다.",
  },
  {
    questionNumber: 29,
    questionText: "Are you done setting up the projector?",
    choices: {
      A: "Yes, it's all working now.",
      B: "I projected the results yesterday.",
      C: "The lights are bright.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "프로젝터 설치를 끝냈나요?",
      choices: {
        A: "네, 지금 모두 작동합니다.",
        B: "어제 결과를 투사했습니다.",
        C: "조명이 밝습니다.",
      },
    },
    explanation:
      "Be동사로 시작하는 yes/no 의문문에 대해 프로젝터 설치 완료 여부를 묻는 질문에는 명확한 답변이 필요합니다. A는 프로젝터가 모두 작동한다고 확인해주는 적절한 응답입니다. B는 과거에 결과를 투사했다는 내용으로 현재 설치 상태와 관련이 없으며, C는 조명 밝기에 관한 내용으로 질문에 대한 직접적인 답변이 아닙니다.",
  },
  {
    questionNumber: 30,
    questionText: "Are we allowed to use this meeting room?",
    choices: {
      A: "No, it's reserved for HR.",
      B: "The chairs are black.",
      C: "We met here last week.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "우리가 이 회의실을 사용해도 되나요?",
      choices: {
        A: "아니요, HR 부서를 위해 예약되어 있습니다.",
        B: "의자들이 검은색입니다.",
        C: "우리는 지난주에 여기서 만났습니다.",
      },
    },
    explanation:
      "Be동사로 시작하는 yes/no 의문문에 대해 회의실 사용 가능 여부를 묻는 질문에는 명확한 답변이 필요합니다. A는 회의실이 HR 부서를 위해 예약되어 있어 사용할 수 없다는 적절한 응답입니다. B는 의자 색상에 관한 내용으로 회의실 사용 가능 여부와 관련이 없으며, C는 과거에 회의실을 사용했다는 내용으로 현재 사용 가능 여부에 대한 직접적인 답변이 아닙니다.",
  },
  {
    questionNumber: 31,
    questionText: "This is your seat near the window, isn't it?",
    choices: {
      A: "No, I prefer the aisle.",
      B: "The seat was comfortable.",
      C: "I think I booked a different one.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "이것이 창가 쪽 당신의 좌석이죠, 그렇지 않나요?",
      choices: {
        A: "아니요, 저는 통로 쪽을 선호합니다.",
        B: "좌석이 편안했습니다.",
        C: "제가 다른 좌석을 예약한 것 같습니다.",
      },
    },
    explanation:
      "부가의문문 형태의 질문에 대해 창가 좌석이 본인의 것인지 확인하는 질문입니다. C는 다른 좌석을 예약했다고 말하며 질문에 적절하게 응답합니다. A는 통로 쪽을 선호한다고 말하지만 부가의문문의 확인 요청에 직접적으로 응답하지 않으며, B는 좌석의 편안함에 대해 언급하지만 좌석 소유 여부에 대한 답변이 아닙니다.",
  },
  {
    questionNumber: 32,
    questionText: "You've already signed the contract, haven't you?",
    choices: {
      A: "No, I'm still reviewing it.",
      B: "Yes, I contacted the client.",
      C: "That contract was long.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "당신은 이미 계약서에 서명했죠, 그렇지 않나요?",
      choices: {
        A: "아니요, 아직 검토 중입니다.",
        B: "네, 고객에게 연락했습니다.",
        C: "그 계약서는 길었습니다.",
      },
    },
    explanation:
      "부가의문문 형태의 질문에 대해 계약서 서명 여부를 확인하는 질문입니다. A는 아직 검토 중이라고 명확하게 응답하여 서명하지 않았음을 알려줍니다. B는 고객 연락에 관한 내용으로 서명 여부와 관련이 없으며, C는 계약서의 길이에 대한 언급으로 서명 여부에 대한 직접적인 답변이 아닙니다.",
  },
  {
    questionNumber: 33,
    questionText: "That's the new intern from HR, isn't it?",
    choices: {
      A: "HR handles recruitment.",
      B: "No, she's from accounting.",
      C: "Internships usually last three months.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "저 사람이 인사부의 새 인턴이죠, 그렇지 않나요?",
      choices: {
        A: "인사부는 채용을 담당합니다.",
        B: "아니요, 그녀는 회계부 소속입니다.",
        C: "인턴십은 보통 3개월 지속됩니다.",
      },
    },
    explanation:
      "부가의문문 형태의 질문에 대해 특정 인턴의 소속 부서를 확인하는 질문입니다. B는 그 인턴이 인사부가 아닌 회계부 소속이라고 명확하게 정정합니다. A는 인사부의 역할에 대한 일반적인 설명으로 특정 인턴에 대한 답변이 아니며, C는 인턴십 기간에 대한 일반적인 정보로 질문에 대한 직접적인 응답이 아닙니다.",
  },
  {
    questionNumber: 34,
    questionText: "You're coming to the training on Friday, aren't you?",
    choices: {
      A: "No, I have another meeting.",
      B: "Training sessions are usually long.",
      C: "Yes, we had one last month.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "금요일 교육에 오실 거죠, 그렇지 않나요?",
      choices: {
        A: "아니요, 다른 회의가 있습니다.",
        B: "교육 세션은 보통 길게 진행됩니다.",
        C: "네, 지난달에 하나 있었습니다.",
      },
    },
    explanation:
      "부가의문문 형태의 질문에 대해 금요일 교육 참석 여부를 확인하는 질문입니다. A는 다른 회의가 있어 참석할 수 없다고 명확하게 응답합니다. B는 교육 세션의 길이에 대한 일반적인 설명으로 참석 여부와 관련이 없으며, C는 지난달 교육에 대한 언급으로 금요일 교육 참석 여부에 대한 직접적인 답변이 아닙니다.",
  },
  {
    questionNumber: 35,
    questionText: "This file should go to Mr. Han, shouldn't it?",
    choices: {
      A: "Mr. Han is the team leader.",
      B: "No, it's for Ms. Kim instead.",
      C: "It's a very long file.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "이 파일은 한 씨에게 전달되어야 하죠, 그렇지 않나요?",
      choices: {
        A: "한 씨는 팀장입니다.",
        B: "아니요, 김 씨에게 전달해야 합니다.",
        C: "매우 긴 파일입니다.",
      },
    },
    explanation:
      "부가의문문 형태의 질문에 대해 파일 전달 대상을 확인하는 질문입니다. B는 파일이 한 씨가 아닌 김 씨에게 전달되어야 한다고 명확하게 정정합니다. A는 한 씨의 직위에 대한 정보로 파일 전달 대상에 대한 직접적인 답변이 아니며, C는 파일의 길이에 대한 언급으로 전달 대상과 관련이 없습니다.",
  },
  {
    questionNumber: 36,
    questionText: "That was your voice on the announcement, wasn't it?",
    choices: {
      A: "I announced it myself.",
      B: "Yes, I recorded it yesterday.",
      C: "The announcement was loud.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "그 안내방송의 목소리가 당신 것이었죠, 그렇지 않나요?",
      choices: {
        A: "제가 직접 발표했습니다.",
        B: "네, 어제 녹음했습니다.",
        C: "안내방송이 크게 들렸습니다.",
      },
    },
    explanation:
      "부가의문문 형태의 질문에 대해 안내방송 목소리의 주인을 확인하는 질문입니다. B는 어제 녹음했다고 확인해주며 자신의 목소리였음을 명확히 답변합니다. A는 직접 발표했다는 내용으로 녹음된 안내방송에 대한 명확한 확인이 아니며, C는 안내방송의 볼륨에 대한 언급으로 목소리 주인에 대한 답변이 아닙니다.",
  },
  {
    questionNumber: 37,
    questionText: "You've met the new client already, haven't you?",
    choices: {
      A: "Yes, we had a call on Monday.",
      B: "The client is very important.",
      C: "I will send the invoice.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "이미 새 고객을 만났죠, 그렇지 않나요?",
      choices: {
        A: "네, 월요일에 통화했습니다.",
        B: "그 고객은 매우 중요합니다.",
        C: "청구서를 보내겠습니다.",
      },
    },
    explanation:
      "부가의문문 형태의 질문에 대해 새 고객과의 만남 여부를 확인하는 질문입니다. A는 월요일에 통화했다고 확인해주며 고객과 이미 접촉했음을 명확히 답변합니다. B는 고객의 중요성에 대한 언급으로 만남 여부와 직접적인 관련이 없으며, C는 청구서 발송에 관한 내용으로 고객 만남에 대한 답변이 아닙니다.",
  },
  {
    questionNumber: 38,
    questionText: "This isn't the final draft, is it?",
    choices: {
      A: "No, I still have to revise it.",
      B: "It's a final version.",
      C: "I drafted something yesterday.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "이것은 최종 초안이 아니죠, 그렇죠?",
      choices: {
        A: "아니요, 아직 수정해야 합니다.",
        B: "최종 버전입니다.",
        C: "어제 무언가를 초안으로 작성했습니다.",
      },
    },
    explanation:
      "부가의문문 형태의 질문에 대해 문서가 최종 초안인지 확인하는 질문입니다. A는 아직 수정이 필요하다고 말하며 최종 초안이 아님을 확인해줍니다. B는 최종 버전이라고 말하지만 질문의 부정 형태와 일치하지 않으며, C는 어제 초안 작성에 관한 내용으로 현재 문서의 상태에 대한 직접적인 답변이 아닙니다.",
  },
  {
    questionNumber: 39,
    questionText: "That's the form we need to submit, isn't it?",
    choices: {
      A: "No, that's just a sample.",
      B: "Submissions are due Friday.",
      C: "I filled out a form yesterday.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "저것이 우리가 제출해야 하는 양식이죠, 그렇지 않나요?",
      choices: {
        A: "아니요, 그것은 단지 견본입니다.",
        B: "제출 마감일은 금요일입니다.",
        C: "어제 양식을 작성했습니다.",
      },
    },
    explanation:
      "부가의문문 형태의 질문에 대해 특정 양식의 제출 필요성을 확인하는 질문입니다. A는 그것이 견본일 뿐이라고 명확하게 정정합니다. B는 제출 마감일에 관한 정보로 양식의 정체성에 대한 직접적인 답변이 아니며, C는 과거 양식 작성에 관한 내용으로 현재 양식에 대한 답변이 아닙니다.",
  },
  {
    questionNumber: 40,
    questionText: "You're working late again tonight, aren't you?",
    choices: {
      A: "Yes, I have a deadline.",
      B: "I left early yesterday.",
      C: "The office closes at 8.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "오늘 밤에도 늦게까지 일하시죠, 그렇지 않나요?",
      choices: {
        A: "네, 마감일이 있습니다.",
        B: "어제 일찍 퇴근했습니다.",
        C: "사무실은 8시에 닫습니다.",
      },
    },
    explanation:
      "부가의문문 형태의 질문에 대해 오늘 밤 늦게까지 일할 것인지 확인하는 질문입니다. A는 마감일이 있어 늦게까지 일할 것임을 명확히 확인해줍니다. B는 어제 일찍 퇴근했다는 내용으로 오늘 밤 근무 여부에 대한 직접적인 답변이 아니며, C는 사무실 폐쇄 시간에 관한 정보로 개인의 근무 계획과 관련이 없습니다.",
  },
  {
    questionNumber: 41,
    questionText: "Aren't you supposed to lock the door after closing?",
    choices: {
      A: "It's already locked.",
      B: "I'll turn on the printer.",
      C: "I parked in the front lot.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "문을 닫은 후에 잠가야 하지 않나요?",
      choices: {
        A: "이미 잠겨 있습니다.",
        B: "프린터를 켜겠습니다.",
        C: "앞쪽 주차장에 주차했습니다.",
      },
    },
    explanation:
      "부가의문문 형태의 질문에 대해 문을 잠가야 하는 의무를 확인하는 질문입니다. A는 이미 문이 잠겨 있다고 말하며 적절한 응답입니다. B는 프린터를 켜는 것에 관한 내용으로 문 잠금과 관련이 없으며, C는 주차 위치에 관한 내용으로 문 잠금 의무와 전혀 관련이 없습니다.",
  },
  {
    questionNumber: 42,
    questionText: "Didn't she say the meeting was canceled?",
    choices: {
      A: "The projector isn't working.",
      B: "Yes, that's what I heard too.",
      C: "I think it's on the shelf.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "그녀가 회의가 취소되었다고 말하지 않았나요?",
      choices: {
        A: "프로젝터가 작동하지 않습니다.",
        B: "네, 저도 그렇게 들었습니다.",
        C: "선반 위에 있는 것 같습니다.",
      },
    },
    explanation:
      "부가의문문 형태의 질문에 대해 회의 취소에 관한 정보를 확인하는 질문입니다. B는 회의 취소에 대해 들었다고 확인해주는 적절한 응답입니다. A는 프로젝터 작동 문제에 관한 내용으로 회의 취소와 직접적인 관련이 없으며, C는 무언가가 선반 위에 있다는 내용으로 회의 취소와 관련이 없습니다.",
  },
  {
    questionNumber: 43,
    questionText: "Isn't the manager coming to the presentation?",
    choices: {
      A: "She has another appointment.",
      B: "The presentation was printed.",
      C: "I prefer a different manager.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "매니저가 발표에 오지 않나요?",
      choices: {
        A: "그녀는 다른 약속이 있습니다.",
        B: "발표자료가 인쇄되었습니다.",
        C: "저는 다른 매니저를 선호합니다.",
      },
    },
    explanation:
      "부가의문문 형태의 질문에 대해 매니저의 발표 참석 여부를 확인하는 질문입니다. A는 매니저가 다른 약속이 있어 참석하지 않을 것임을 설명하는 적절한 응답입니다. B는 발표자료 인쇄에 관한 내용으로 매니저의 참석과 관련이 없으며, C는 개인적인 매니저 선호도에 관한 내용으로 질문에 대한 직접적인 답변이 아닙니다.",
  },
  {
    questionNumber: 44,
    questionText: "Haven't they already submitted the report?",
    choices: {
      A: "Not yet, they're still working on it.",
      B: "The projector isn't plugged in.",
      C: "Reports are usually long.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "그들이 이미 보고서를 제출하지 않았나요?",
      choices: {
        A: "아직 아닙니다, 그들은 여전히 작업 중입니다.",
        B: "프로젝터가 연결되어 있지 않습니다.",
        C: "보고서는 보통 깁니다.",
      },
    },
    explanation:
      "부가의문문 형태의 질문에 대해 보고서 제출 여부를 확인하는 질문입니다. A는 아직 보고서가 제출되지 않았고 작업 중이라고 명확히 답변합니다. B는 프로젝터 연결에 관한 내용으로 보고서 제출과 관련이 없으며, C는 보고서의 일반적인 길이에 관한 정보로 제출 여부와 관련이 없습니다.",
  },
  {
    questionNumber: 45,
    questionText: "Didn't you book the conference room?",
    choices: {
      A: "Yes, it's reserved from 2 to 4.",
      B: "The air conditioner is broken.",
      C: "I sent him the file.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "회의실을 예약하지 않았나요?",
      choices: {
        A: "네, 2시부터 4시까지 예약되어 있습니다.",
        B: "에어컨이 고장났습니다.",
        C: "그에게 파일을 보냈습니다.",
      },
    },
    explanation:
      "부가의문문 형태의 질문에 대해 회의실 예약 여부를 확인하는 질문입니다. A는 2시부터 4시까지 예약했다고 확인해주는 적절한 응답입니다. B는 에어컨 고장에 관한 내용으로 회의실 예약과 직접적인 관련이 없으며, C는 파일 전송에 관한 내용으로 회의실 예약과 관련이 없습니다.",
  },
  {
    questionNumber: 46,
    questionText: "Isn't this the wrong form?",
    choices: {
      A: "I parked on the second level.",
      B: "You're right — this isn't the updated one.",
      C: "Form submissions are open all day.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "이것은 잘못된 양식이 아닌가요?",
      choices: {
        A: "저는 2층에 주차했습니다.",
        B: "맞습니다 ,  이것은 업데이트된 것이 아닙니다.",
        C: "양식 제출은 하루 종일 가능합니다.",
      },
    },
    explanation:
      "부가의문문 형태의 질문에 대해 양식의 정확성을 확인하는 질문입니다. B는 양식이 업데이트되지 않은 잘못된 것임을 확인해주는 적절한 응답입니다. A는 주차 위치에 관한 내용으로 양식의 정확성과 관련이 없으며, C는 양식 제출 시간에 관한 정보로 현재 양식의 정확성에 대한 직접적인 답변이 아닙니다.",
  },
  {
    questionNumber: 47,
    questionText: "Hasn't the delivery arrived yet?",
    choices: {
      A: "No, it should be here by noon.",
      B: "Please arrange the chairs.",
      C: "The lobby was cleaned yesterday.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "배송이 아직 도착하지 않았나요?",
      choices: {
        A: "아니요, 정오까지 도착할 예정입니다.",
        B: "의자를 정리해 주세요.",
        C: "로비는 어제 청소되었습니다.",
      },
    },
    explanation:
      "부가의문문 형태의 질문에 대해 배송 도착 여부를 확인하는 질문입니다. A는 배송이 아직 도착하지 않았고 정오까지 도착할 것이라고 명확히 답변합니다. B는 의자 정리에 관한 요청으로 배송 도착과 관련이 없으며, C는 로비 청소에 관한 내용으로 배송 도착과 관련이 없습니다.",
  },
  {
    questionNumber: 48,
    questionText: "Wasn't this project due yesterday?",
    choices: {
      A: "I'll return the projector.",
      B: "That's correct, we're running a bit behind.",
      C: "Projects are listed on the website.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "이 프로젝트 마감일이 어제가 아니었나요?",
      choices: {
        A: "프로젝터를 반납하겠습니다.",
        B: "맞습니다, 우리는 약간 지연되고 있습니다.",
        C: "프로젝트는 웹사이트에 나열되어 있습니다.",
      },
    },
    explanation:
      "부가의문문 형태의 질문에 대해 프로젝트 마감일을 확인하는 질문입니다. B는 마감일이 어제였음을 확인하고 지연되고 있다고 설명하는 적절한 응답입니다. A는 프로젝터 반납에 관한 내용으로 프로젝트 마감일과 관련이 없으며, C는 프로젝트 목록 위치에 관한 정보로 마감일에 대한 직접적인 답변이 아닙니다.",
  },
  {
    questionNumber: 49,
    questionText: "Didn't you already email the final version?",
    choices: {
      A: "Yes, I sent it right after lunch.",
      B: "The printer ran out of paper.",
      C: "The email server was restarted.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "최종 버전을 이미 이메일로 보내지 않았나요?",
      choices: {
        A: "네, 점심 식사 직후에 보냈습니다.",
        B: "프린터의 종이가 떨어졌습니다.",
        C: "이메일 서버가 재시작되었습니다.",
      },
    },
    explanation:
      "부가의문문 형태의 질문에 대해 최종 버전 이메일 발송 여부를 확인하는 질문입니다. A는 점심 식사 직후에 이메일을 보냈다고 확인해주는 적절한 응답입니다. B는 프린터 종이 부족에 관한 내용으로 이메일 발송과 관련이 없으며, C는 이메일 서버 재시작에 관한 정보로 최종 버전 발송 여부에 대한 직접적인 답변이 아닙니다.",
  },
  {
    questionNumber: 50,
    questionText: "Isn't he working remotely this week?",
    choices: {
      A: "He's using the shared desk today.",
      B: "No, he's in the office now.",
      C: "Remote access is available 24/7.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "그는 이번 주에 원격으로 일하고 있지 않나요?",
      choices: {
        A: "그는 오늘 공유 책상을 사용하고 있습니다.",
        B: "아니요, 그는 지금 사무실에 있습니다.",
        C: "원격 접속은 24시간 가능합니다.",
      },
    },
    explanation:
      "부가의문문 형태의 질문에 대해 특정인의 원격 근무 여부를 확인하는 질문입니다. B는 그가 원격으로 일하지 않고 사무실에 있다고 명확히 답변합니다. A는 공유 책상 사용에 관한 내용으로 원격 근무 여부에 대한 직접적인 답변이 아니며, C는 원격 접속 가능 시간에 관한 정보로 현재 근무 상태에 대한 답변이 아닙니다.",
  },
  {
    questionNumber: 51,
    questionText: "Don't we need a permit to park here?",
    choices: {
      A: "The weather is nice today.",
      B: "A parking garage was built last year.",
      C: "Yes, it's required during weekdays.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "여기에 주차하려면 허가증이 필요하지 않나요?",
      choices: {
        A: "오늘 날씨가 좋습니다.",
        B: "주차장이 작년에 지어졌습니다.",
        C: "네, 평일에는 필수입니다.",
      },
    },
    explanation:
      "부가의문문 형태의 질문에 대해 주차 허가증 필요 여부를 확인하는 질문입니다. C는 평일에 허가증이 필요하다고 명확히 답변합니다. A는 날씨에 관한 내용으로 주차 허가증과 관련이 없으며, B는 주차장 건설에 관한 정보로 허가증 필요 여부에 대한 직접적인 답변이 아닙니다.",
  },
  {
    questionNumber: 52,
    questionText: "Hasn't this printer already been repaired?",
    choices: {
      A: "I ordered more paper.",
      B: "This one is on sale.",
      C: "It was fixed last month, but it broke again.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "이 프린터가 이미 수리되지 않았나요?",
      choices: {
        A: "종이를 더 주문했습니다.",
        B: "이것은 할인 중입니다.",
        C: "지난달에 수리되었지만, 다시 고장났습니다.",
      },
    },
    explanation:
      "부가의문문 형태의 질문에 대해 프린터 수리 여부를 확인하는 질문입니다. C는 프린터가 수리되었으나 다시 고장났다고 명확히 답변합니다. A는 종이 주문에 관한 내용으로 프린터 수리와 관련이 없으며, B는 할인에 관한 정보로 수리 여부에 대한 직접적인 답변이 아닙니다.",
  },
  {
    questionNumber: 53,
    questionText: "Didn't the package arrive this morning?",
    choices: {
      A: "The driver is very polite.",
      B: "I prefer express shipping.",
      C: "Yes, it was dropped off around 9.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "소포가 오늘 아침에 도착하지 않았나요?",
      choices: {
        A: "운전기사가 매우 공손합니다.",
        B: "저는 특급 배송을 선호합니다.",
        C: "네, 9시경에 배달되었습니다.",
      },
    },
    explanation:
      "부가의문문 형태의 질문에 대해 소포 도착 여부를 확인하는 질문입니다. C는 소포가 9시경에 배달되었다고 명확히 답변합니다. A는 운전기사의 태도에 관한 내용으로 소포 도착과 직접적인 관련이 없으며, B는 배송 방식 선호도에 관한 정보로 소포 도착 여부에 대한 직접적인 답변이 아닙니다.",
  },
  {
    questionNumber: 54,
    questionText: "Wasn't the break room cleaned yesterday?",
    choices: {
      A: "We have a meeting at 4.",
      B: "Yes, but it got messy again quickly.",
      C: "Cleaning supplies are in the closet.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "휴게실이 어제 청소되지 않았나요?",
      choices: {
        A: "4시에 회의가 있습니다.",
        B: "네, 하지만 빠르게 다시 지저분해졌습니다.",
        C: "청소 용품은 옷장에 있습니다.",
      },
    },
    explanation:
      "부가의문문 형태의 질문에 대해 휴게실 청소 여부를 확인하는 질문입니다. B는 휴게실이 청소되었으나 다시 지저분해졌다고 명확히 답변합니다. A는 회의 시간에 관한 내용으로 휴게실 청소와 관련이 없으며, C는 청소 용품 위치에 관한 정보로 청소 여부에 대한 직접적인 답변이 아닙니다.",
  },
  {
    questionNumber: 55,
    questionText: "Don't these instructions seem confusing?",
    choices: {
      A: "I saw him in the hallway.",
      B: "The manual is printed in color.",
      C: "Yes, I had trouble understanding them.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "이 지시사항들이 혼란스럽게 보이지 않나요?",
      choices: {
        A: "복도에서 그를 보았습니다.",
        B: "설명서는 컬러로 인쇄되어 있습니다.",
        C: "네, 이해하는 데 어려움이 있었습니다.",
      },
    },
    explanation:
      "부가의문문 형태의 질문에 대해 지시사항의 명확성을 확인하는 질문입니다. C는 지시사항을 이해하기 어려웠다고 명확히 답변합니다. A는 누군가를 본 것에 관한 내용으로 지시사항과 관련이 없으며, B는 설명서 인쇄 방식에 관한 정보로 지시사항의 명확성에 대한 직접적인 답변이 아닙니다.",
  },
  {
    questionNumber: 56,
    questionText: "Hasn't the deadline already passed?",
    choices: {
      A: "No, it's been extended to Friday.",
      B: "I'm using a red folder.",
      C: "That document needs editing.",
    },
    incorrectAnswers: ["B", "C"],
    translation: {
      question: "마감일이 이미 지나지 않았나요?",
      choices: {
        A: "아니요, 금요일로 연장되었습니다.",
        B: "빨간색 폴더를 사용하고 있습니다.",
        C: "그 문서는 편집이 필요합니다.",
      },
    },
    explanation:
      "부가의문문 형태의 질문에 대해 마감일 경과 여부를 확인하는 질문입니다. A는 마감일이 금요일로 연장되었다고 명확히 답변합니다. B는 폴더 색상에 관한 내용으로 마감일과 관련이 없으며, C는 문서 편집 필요성에 관한 정보로 마감일 경과 여부에 대한 직접적인 답변이 아닙니다.",
  },
  {
    questionNumber: 57,
    questionText: "Didn't we pay that invoice last week?",
    choices: {
      A: "I left my keys at the front desk.",
      B: "Yes, I processed it on Thursday.",
      C: "It's stored in the drawer.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "지난주에 그 청구서를 지불하지 않았나요?",
      choices: {
        A: "열쇠를 프론트 데스크에 두고 왔습니다.",
        B: "네, 목요일에 처리했습니다.",
        C: "서랍에 보관되어 있습니다.",
      },
    },
    explanation:
      "부가의문문 형태의 질문에 대해 청구서 지불 여부를 확인하는 질문입니다. B는 목요일에 청구서를 처리했다고 명확히 답변합니다. A는 열쇠 위치에 관한 내용으로 청구서 지불과 전혀 관련이 없으며, C는 청구서 보관 위치에 관한 정보로 지불 여부에 대한 직접적인 답변이 아닙니다.",
  },
  {
    questionNumber: 58,
    questionText: "Wasn't this item returned before?",
    choices: {
      A: "Items are arranged by category.",
      B: "The stockroom is locked.",
      C: "Yes, but the customer sent it back again.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "이 물품이 전에 반품되지 않았나요?",
      choices: {
        A: "물품들은 카테고리별로 정리되어 있습니다.",
        B: "창고는 잠겨 있습니다.",
        C: "네, 하지만 고객이 다시 보냈습니다.",
      },
    },
    explanation:
      "부가의문문 형태의 질문에 대해 물품 반품 이력을 확인하는 질문입니다. C는 물품이 반품되었으나 고객이 다시 보냈다고 명확히 답변합니다. A는 물품 정리 방식에 관한 내용으로 반품 이력과 관련이 없으며, B는 창고 상태에 관한 정보로 반품 여부에 대한 직접적인 답변이 아닙니다.",
  },
  {
    questionNumber: 59,
    questionText: "Don't these cables need to be labeled?",
    choices: {
      A: "I left my charger at home.",
      B: "The cables are expensive.",
      C: "Yes, to avoid confusion later.",
    },
    incorrectAnswers: ["A", "B"],
    translation: {
      question: "이 케이블들에 라벨을 붙일 필요가 없나요?",
      choices: {
        A: "충전기를 집에 두고 왔습니다.",
        B: "케이블들이 비쌉니다.",
        C: "네, 나중에 혼란을 피하기 위해서요.",
      },
    },
    explanation:
      "부가의문문 형태의 질문에 대해 케이블 라벨링 필요성을 확인하는 질문입니다. C는 나중에 혼란을 피하기 위해 라벨이 필요하다고 명확히 답변합니다. A는 충전기에 관한 내용으로 케이블 라벨링과 관련이 없으며, B는 케이블 가격에 관한 정보로 라벨링 필요성에 대한 직접적인 답변이 아닙니다.",
  },
  {
    questionNumber: 60,
    questionText: "Hasn't the technician already left?",
    choices: {
      A: "He fixed the air conditioner last time.",
      B: "No, he's still in the back office.",
      C: "The system crashed again.",
    },
    incorrectAnswers: ["A", "C"],
    translation: {
      question: "기술자가 이미 떠나지 않았나요?",
      choices: {
        A: "그는 지난번에 에어컨을 수리했습니다.",
        B: "아니요, 그는 아직 뒤쪽 사무실에 있습니다.",
        C: "시스템이 다시 다운되었습니다.",
      },
    },
    explanation:
      "부가의문문 형태의 질문에 대해 기술자의 현재 위치를 확인하는 질문입니다. B는 기술자가 아직 뒤쪽 사무실에 있다고 명확히 답변합니다. A는 과거 수리 내용에 관한 정보로 현재 위치와 관련이 없으며, C는 시스템 상태에 관한 정보로 기술자의 현재 위치에 대한 직접적인 답변이 아닙니다.",
  },
];
